/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {SpinServerDataParser} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinServerDataParser";

export class WinterHoardServerDataParser extends SpinServerDataParser {

    constructor() {
        super();
    }
/*
    parseNearWinReels(rawData:IGameData):boolean[] {
        return [false,false,true,true,true];
    }*/
}